import toast from 'react-hot-toast';

export const copyToClipboard = text => {
  console.log('Copied', text);
  navigator.clipboard.writeText(text);
  toast.success('Copied to clipboard');
};
